import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <p>© 2026 Pandey Rabin. All Rights Reserved.</p>
    </footer>
  );
};

export default Footer;